import React, { Component, Fragment } from "react";
import { Card, Table, Button, Avatar, notification, Tag } from "antd";
import "./singleInvoice.css";
import appConfig from "../../helpers/appConfig";
// import { Icon as RIcon } from "react-icons-kit";

const { Meta } = Card;

const columns = [
  {
    title: "Sr Nr.",
    dataIndex: "no"
  },
  {
    title: "Navn",
    dataIndex: "name"
  },
  {
    title: "QTY",
    dataIndex: "quantity"
  },
  {
    title: "Pris",
    dataIndex: "price"
  },
  {
    title: "Ekstra vare Pris",
    dataIndex: "extraPrice"
  },
  {
    title: "Beløp",
    dataIndex: "amount"
  }
];

const gridStyle = {
  flex: "1 0 50%",
  maxWidth: "50%",
  padding: "10px",
  boxShadow: "none",
  border: "none"
};

const fullWidth = {
  flex: "1 0 100%",
  boxShadow: "none",
  border: "none"
};

class SingleInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
    console.log("brbrbr", this.props.branch);
  }

  markPaid = (id) => {
    const hdr = localStorage.token;
    fetch(`${appConfig.endpoint}/invoice/${id}`, {
      method: "PUT",
      headers: {
        "x-auth-token": hdr
      }
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status === "failure") {
            this.openNotification("error", result.message);
          } else {
            this.openNotification("success", result.message);
          }
        },
        (error) => {
          console.log(error);
          this.setState({
            error
          });
        }
      );
  };

  openNotification = (type, message) => {
    notification[type]({
      message: message
    });
  };
  printbill = () => {
    window.print();
  };

  render() {
    const branchInfo = JSON.parse(localStorage.getItem("branchInfo"));
    const branchLogo = localStorage.getItem("logo");
    const { data } = this.props;
    const { customerId, isPaid, _id } = this.props.data;
    const { name, address, taxNo, phoneNo, bEmail, accountNumber } = branchInfo;
    const table = data.items;
    let tableData = table.map((item, index) => {
      let ext = item.extraPrice ? item.extraPrice : 0;
      return {
        no: index + 1,
        name: item.productName,
        quantity: item.quantity,
        price: `Kr.${item.productPrice}`,
        extraPrice: `Kr.${ext}`,
        amount: `Kr.${Number(item.quantity * item.productPrice + ext)}`
      };
    });
    return (
      <div
        id="singleinvoice"
        style={{
          margin: "10px auto",
          //  justifyContent: "center",
          borderWidth: 1,
          borderColor: "green"
        }}
        className="single-invoice"
      >
        <Card>
          <div id="printbtn">
            <Button
              onClick={this.printbill}
              style={{
                background: "transparent",
                color: "black",
                border: "1px solid grey",
                float: "right",
                marginLeft: "120px"
              }}
            >
              Skrive ut
            </Button>
          </div>
          <Meta
            avatar={
              <Avatar
                src={
                  branchLogo === null ? "" : `${appConfig.s3url}/${branchLogo}`
                }
              />
            }
            title={name}
          />

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <Card.Grid style={gridStyle}>
              {address && (
                <>
                  <p>
                    {address.line1 ? address.lin1 : ""}
                    {address.line2 ? " " + address.line2 : ""}
                  </p>
                  <p>
                    {address.city ? address.city : ""}
                    {address.pin ? "," + " " + address.pin : ""}
                    {address.state ? "," + " " + address.state : ""}
                  </p>
                  <p>
                    <b>Moms Nr.</b>: {taxNo}
                  </p>
                  {!isPaid ? (
                    <p>
                      <b>Regnskap Nr. </b>: {accountNumber}
                    </p>
                  ) : null}
                  <p>
                    <b>Telefon Nr.</b>: {phoneNo}
                  </p>
                  <p>
                    <b>E-post</b>: {bEmail}
                  </p>
                </>
              )}
            </Card.Grid>
            <Card.Grid style={{ ...gridStyle, textAlign: "right" }}>
              <p>
                <b>Faktura Nr.</b>: {data.invoiceNumber}
              </p>
              <p>
                <b>Dato</b>: {data.createdDate}
              </p>
              <p>
                <b>Tid</b>: {data.createdTime}
              </p>
              <p>
                <b>Bestillingstype</b>: {data.orderType}
              </p>
            </Card.Grid>
            <hr />
            {customerId ? (
              <Card.Grid style={gridStyle}>
                <h3>KUNDEDETALJER :</h3>
                <hr />
                <p>
                  <strong>
                    {customerId.firstName} {customerId.lastName}
                  </strong>
                </p>

                <p>{customerId.address.line1}</p>
                <p>{customerId.address.line2}</p>

                {customerId.address.line1 ? (
                  <p>
                    {customerId.address.city}{" "}
                    {customerId.address.pin ? "," + customerId.address.pin : ""}{" "}
                    {customerId.address.state
                      ? "," + customerId.address.state
                      : ""}
                  </p>
                ) : (
                  ""
                )}
              </Card.Grid>
            ) : (
              <h4 style={{ marginLeft: 10, fontWeight: "bold", color: "grey" }}>
                No Customer Details
              </h4>
            )}
            {customerId ? (
              <Card.Grid
                style={{
                  ...gridStyle,
                  flex: "auto",
                  marginTop: 15,
                  textAlign: "right"
                }}
              >
                <p>
                  <b>Telefon:</b> {customerId.phoneNo}
                </p>
                <p>
                  <b>e-post:</b> {customerId.email}
                </p>
                <p>
                  <b>Referanse:</b> {data.reference}
                </p>
              </Card.Grid>
            ) : (
              ""
            )}
            {/* </div> */}
            {/* <br /> */}
            {/* <Card.Grid style={gridStyle}>
              <h3>BILLING DETAILS :</h3>
              <hr />
            </Card.Grid> */}
            <hr />
            <Table
              id="producttab"
              style={{ ...fullWidth, marginTop: 20 }}
              columns={columns}
              dataSource={tableData}
              size="middle"
              pagination={false}
            />
            <Card.Grid
              style={{
                ...fullWidth,
                textAlign: "right",
                paddingRight: "0 40px",
                lineHeight: 1.65
              }}
            >
              <p>
                <span style={{ fontWeight: 700 }}>Sub-Totalt: </span>
                <span style={{ minWidth: "100px", display: "inline-block" }}>
                  {`Kr.${(
                    data.taxPrice -
                    (
                      data.taxPrice -
                      (100 * data.taxPrice) / (100 + data.tax)
                    ).toFixed(3)
                  ).toFixed(2)}`}
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 700 }}>
                  Moms(
                  {`${data.tax.toFixed(2)}%`}
                  ):{" "}
                </span>
                <span style={{ minWidth: "100px", display: "inline-block" }}>
                  {`Kr.${(
                    data.taxPrice -
                    (100 * data.taxPrice) / (100 + data.tax)
                  ).toFixed(2)}`}
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 700 }}>
                  Rabatt (
                  {data.discountType === "percent" ? `${data.discount}%` : "0%"}
                  ) :
                </span>
                <span style={{ minWidth: "100px", display: "inline-block" }}>
                  {`- Kr.${(
                    (100 * Number(data.taxPrice)) / (100 - data.discount) -
                    data.taxPrice
                  ).toFixed(2)}`}
                </span>
              </p>
              {data.flatDiscount && data.flatDiscount !== 0 ? (
                <p>
                  <span style={{ fontWeight: 700 }}>
                    Flat Rabatt (kr.{data.flatDiscount}) :
                  </span>
                  <span style={{ minWidth: "100px", display: "inline-block" }}>
                    {`-
                    Kr.${Number(data.flatDiscount).toFixed(3)}`}
                  </span>
                </p>
              ) : null}

              {data.orderType == "Drive Out" ? (
                <p>
                  <p>
                    {" "}
                    <span style={{ fontWeight: 700 }}>Drive Out Tax (25%)</span>
                    <span
                      style={{ minWidth: "100px", display: "inline-block" }}
                    >
                      {`+ Kr.${(
                        data.driveoutCharge +
                        data.extraDriveOut -
                        (100 * (data.driveoutCharge + data.extraDriveOut)) / 125
                      ).toFixed(2)}`}
                    </span>
                  </p>
                  <p>
                    {" "}
                    <span style={{ fontWeight: 700 }}>Drive Out Charges</span>
                    <span
                      style={{ minWidth: "100px", display: "inline-block" }}
                    >
                      {`+ Kr.${(
                        (100 * (data.driveoutCharge + data.extraDriveOut)) /
                        125
                      ).toFixed(2)}`}
                    </span>
                  </p>
                  <span style={{ fontWeight: 700 }}>Totalt:</span>
                  <span style={{ minWidth: "100px", display: "inline-block" }}>
                    {`Kr.${parseFloat(data.totalPrice).toFixed(2)}`}
                  </span>
                </p>
              ) : (
                <span>
                  <span style={{ fontWeight: 700 }}>Totalt:</span>
                  <span style={{ minWidth: "100px", display: "inline-block" }}>
                    {`Kr.${parseFloat(data.taxPrice).toFixed(2)}`}
                  </span>
                </span>
              )}

              <br />
              <span>
                <span style={{ fontWeight: 700 }}>CASH:</span>

                <span style={{ minWidth: "100px", display: "inline-block" }}>
                  <Tag
                    color={data.cash !== 0 ? "#87d068" : "grey"}
                  >{`Kr.${parseFloat(data.cash).toFixed(2)}`}</Tag>
                </span>
              </span>
              <br />
              <span>
                <span style={{ fontWeight: 700 }}>BANK:</span>
                <span style={{ minWidth: "100px", display: "inline-block" }}>
                  <Tag
                    color={data.bank !== 0 ? "#87d068" : "grey"}
                  >{`Kr.${parseFloat(data.bank).toFixed(2)}`}</Tag>
                </span>
              </span>
              <br />
              <span>
                {data.transaction && data.transaction.vendorName=="Vipps"? (
                  <>
                    <br />
                    <h4>
                      <b>Paid With Vipps</b>
                    </h4>
                    
                  </>
                ) : data.transaction.card &&(
                  <>
                    <br />
                    <h4>
                      <b>Card Detailssssss</b>
                    </h4>
                    <p>
                      <span style={{ fontWeight: 700 }}>Card:</span>
                      <span
                        style={{ minWidth: "100px", display: "inline-block" }}
                      >
                        {data.transaction.card.masked_pan}
                      </span>
                      <br />
                      <span style={{ fontWeight: 700 }}>Card Type:</span>
                      <span
                        style={{ minWidth: "100px", display: "inline-block" }}
                      >
                        {data.transaction.card.brand}
                      </span>
                      <br />
                      <span style={{ fontWeight: 700 }}>Expiry Date:</span>
                      <span
                        style={{ minWidth: "100px", display: "inline-block" }}
                      >
                        {data.transaction.card.expiry_date}
                      </span>
                    </p>
                  </>
                )}
              </span>
              <span>
                {isPaid ? (
                  ""
                ) : (
                  <Button
                    id="markpaidbtn"
                    style={{ margin: "20px 0" }}
                    type="danger"
                    onClick={() => this.markPaid(_id)}
                  >
                    Ubetalt
                  </Button>
                )}
                {/* <Button
                  id="markrevertbtn"
                  style={{ margin: "20px 10px" }}
                  type="danger"
                  title="REVERT INVOICE"
                  onClick={() => this.markPaid(_id)}
                /> */}
              </span>
              <br />
              <span></span>
            </Card.Grid>
          </div>
        </Card>
      </div>
    );
  }
}

export default SingleInvoice;
